{#if popup }
<div class="popover is-popover-bottom nav-popover">
  <a on:click|stopPropagation={showPopup} class="show-popup button is-small mr-2 popover-trigger" title="Info Popup anzeigen"><Icon
    icon="info"
    size="medium"
    iconSize="fa-1x"
    type="grey"
  /></a>
  <div class="popover-content">
    Informationspopup anzeigen
  </div>
</div>
{/if}

<script>
import { onMount } from "svelte";
import Icon from "../Icon.svelte";
import { progressSvc } from "../services";
import { currentPopup, userProgress } from "../stores";
let popup, up;

const showPopup = () => {
  up.closedPopups && delete up.closedPopups[popup.routeKey];
  progressSvc.setUserProgress(up);
  currentPopup.set(popup);
}

onMount(() => {
  currentPopup.subscribe(p => {
    popup = p;
  });
  userProgress.subscribe(data => up = data);
});
</script>
<style type="text/scss">
.backdrop {
  background: rgba(0,0,0, 0.3);
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 10;
  padding-top: 20vh;
}
.modal-container {
  position: relative;
  border-radius: 4px;
  margin: 0 auto;
}
.close-popup {
  position: absolute;
  top: 0px;
  right: 0px;
}
:global(body.begolf-has-popup .section:not(.backdrop)) {
  filter: blur(2px);
}
</style>